import { render, staticRenderFns } from "./FooterCompo.vue?vue&type=template&id=729f7e1e&scoped=true&"
import script from "./FooterCompo.vue?vue&type=script&lang=js&"
export * from "./FooterCompo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729f7e1e",
  null
  
)

export default component.exports